import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card drifts in sideways like a leaf settling. */
export const seasonsCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const travel = isMobile ? 48 : 64;
  return {
    variants: {
      enter: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? travel : -travel, y: -18, rotate: direction > 0 ? 4 : -4 }),
      center: { opacity: 1, x: 0, y: 0, rotate: 0 },
      exit: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? -travel : travel, y: 22, rotate: direction > 0 ? -5 : 5 }),
    },
    transition: { duration: 0.9, ease: [0.25, 1, 0.5, 1] },
  };
};
